import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ApprovalFlowService } from '../approval-flow-models/approval-flow.service';
import { WorkflowDefination } from '../approval-flow-models/workflow-defination.model';
import { WorkflowCriteria } from '../approval-flow-models/workflow-criteria.model';
import { WorkflowNames } from '../approval-flow-models/workflow-names.model';
import { WorkflowApproval } from '../approval-flow-models/workflow-approval.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { UserManagementService } from 'src/app/service/user-management.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-approval-flow',
  templateUrl: './approval-flow.component.html',
  styleUrls: ['./approval-flow.component.css']
})
export class ApprovalFlowComponent implements OnInit {

  public workFlows: WorkflowNames[] = [];
  public workFlowLevel: WorkflowDefination[] = [];
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  ordersTableColumns3: TableColumn[];
  ordersTableColumns4: TableColumn[];

  actions: any;
  actionButtons: any;
  columnsData: any;
  workflowNames: WorkflowNames[]
  showLoading: boolean;
  workflowDefination: WorkflowDefination = new WorkflowDefination();
  workflowDefinations: WorkflowDefination[];
  workflowDetails: WorkflowDefination[];
  workflowStages: WorkflowDefination[];
  updateWorkflowDetails: WorkflowDefination = new WorkflowDefination();
  approvalTypes: string[] = [];
  timeOutActions: string[] = [];
  approvalCriterias: string[] = [];
  userData: AddUser[];
  approvalValueSet: WorkflowApproval[] = [];
  suppervisorSet = new Set<string>();
  levels: number[] = [];
  stages: number[] = [];
  buttons: Buttons[];
  hideApprovalVal: boolean = false;

  hideApprovalValByUser: boolean = true;
  hideApprovalValByRole: boolean = true;
  hideApprovalValByCustGroup: boolean = true;

  hideApprovalValByUserEdit: boolean = true;
  hideApprovalValByRoleEdit: boolean = true;
  hideApprovalValByCustGroupEdit: boolean = true;

  control = new FormControl();
  filteredApprovalValues: Observable<WorkflowApproval[]> | undefined;
  filteredValues: WorkflowApproval[] = [];
  workflowCriteria: WorkflowCriteria = new WorkflowCriteria();
  workflowsObj: WorkflowNames = new WorkflowNames();
  isSql: boolean = true;
  isSaveCrit = false;
  isSaveFlow = false;
  allWorkflowApprovals: WorkflowApproval[];

  roles: UserManagementModel[];
  timeOutRoleActions: UserManagementModel[];
  timeOutCustGroupActions: WorkflowApproval[];
  timeOutRoleActionsEdit: UserManagementModel[];
  timeOutCustGroupActionsEdit: WorkflowApproval[];

  isAccessDisabled: boolean = false;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  exportExcelMydocModel: WorkflowNames[] = [];

  constructor(private httpService: HttpClient, private approvalFlowService: ApprovalFlowService,
    private manageUserService: ManageUserService, private authgurdService: AuthGaurdService,
    private notificationService: NotificationService, private router: Router, private globalService: GlobalService,
    private usermanagementService: UserManagementService, private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('approval-flow');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }
  }

  init() {
    this.initializeColumns();
    this.loadWorkflowNames();
    //this.getAllUserData();
    this.approvalTypes = [];
    this.initializeExcelHeaders();
    this.getRoles();
    this.getCustGroups();
  }

  getRoles() {
    this.usermanagementService.getRoles().subscribe(
      (response: UserManagementModel[]) => {
        this.timeOutRoleActions = response;
        this.timeOutRoleActionsEdit = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }
  getCustGroups() {
    this.approvalFlowService.getAllApprovalWorkFlows().subscribe(
      (response: WorkflowApproval[]) => {
        this.timeOutCustGroupActions = response;
        this.timeOutCustGroupActionsEdit = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  findApprovalValue(event: any) {
    if (event.target.value === 'By User') {
      this.hideApprovalValByUser = false;
      this.hideApprovalValByRole = true;
      this.hideApprovalValByCustGroup = true;
    } else if (event.target.value === 'By Role') {
      this.hideApprovalValByRole = false;
      this.hideApprovalValByUser = true;
      this.hideApprovalValByCustGroup = true;



    } else if (event.target.value === 'By Cust Group') {
      this.hideApprovalValByCustGroup = false;
      this.hideApprovalValByRole = true;
      this.hideApprovalValByUser = true;



    } else {
      this.hideApprovalValByRole = true;
      this.hideApprovalValByUser = true;
      this.hideApprovalValByCustGroup = true;
    }
  }

  findApprovalEditValue(event: any) {
    if (event.target.value === 'By User') {
      this.hideApprovalValByUserEdit = false;
      this.hideApprovalValByRoleEdit = true;
      this.hideApprovalValByCustGroupEdit = true;
    } else if (event.target.value === 'By Role') {
      this.hideApprovalValByRoleEdit = false;
      this.hideApprovalValByUserEdit = true;
      this.hideApprovalValByCustGroupEdit = true;



    } else if (event.target.value === 'By Cust Group') {
      this.hideApprovalValByCustGroupEdit = false;
      this.hideApprovalValByRoleEdit = true;
      this.hideApprovalValByUserEdit = true;


    } else {
      this.hideApprovalValByRoleEdit = true;
      this.hideApprovalValByUserEdit = true;
      this.hideApprovalValByCustGroupEdit = true;
    }
  }





  loadDropDownValues() {
    this.approvalFlowService.loadDropDownValues()
      .subscribe((data: WorkflowDefination[]) => {
        this.workflowDefinations = data;
        console.log(this.workflowDefinations);
        this.approvalTypes = [];
        this.timeOutActions = [];
        this.approvalCriterias = [];
        for (let workflowDef of this.workflowDefinations) {
          if (workflowDef.approval_type) {
            this.approvalTypes.push(workflowDef.approval_type);
          }
          else if (workflowDef.timeout_action) {
            this.timeOutActions.push(workflowDef.timeout_action);
          }
          else if (workflowDef.approval_criteria) {
            this.approvalCriterias.push(workflowDef.approval_criteria);
          }
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  loadWorkflowNames() {
    this.approvalFlowService.loadWorkflowNames()
      .subscribe((data: WorkflowNames[]) => {
        this.workFlows = data;
        console.log(this.workFlows);
        this.loadDropDownValues();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  rowAction(row: any) {
    console.log(" row ....", row, "=== val  ", row.value);
    if (row.value === 'View') {
      this.findWorkflowDefById(row.row.id)
    }
    if (row.value === 'Update') {
      //this.onEditRole(row.row);
    }
  }

  findWorkflowDefById(id: number) {
    this.approvalFlowService.fetchWorkflowDef(id)
      .subscribe((data: WorkflowDefination[]) => {
        this.workFlowLevel = data;
        this.levels = [];
        for (let workFlowLvl of this.workFlowLevel) {
          this.levels.push(workFlowLvl.level)
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  public deleteWorkflowLevel(flowId: number, level: number): void {
    if (confirm("Are you sure to delete this Record")) {
      this.approvalFlowService.deleteWorkflowLevel(flowId, level).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
    }
  }

  loadStages(flowId: number, level: number) {
    this.stages = [];
    this.approvalFlowService.loadStages(flowId, level)
      .subscribe((data: WorkflowDefination[]) => {
        this.workflowStages = data;
        this.stages = [];
        for (let workFlowStage of this.workflowStages) {
          this.stages.push(workFlowStage.stage);
        }
        console.log(this.stages);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  public deleteWorkflowByStage(id: number): void {
    if (confirm("Are you sure to delete this Record")) {
      this.approvalFlowService.deleteWorkflowStages(id).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
    }
  }



  findStages() {
    this.loadStages(this.workflowDefination.flowId, this.workflowDefination.level);
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelMyWorkflowList;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  public exportExcel() {
    this.exportExcelMydocModel = JSON.parse(JSON.stringify(this.workFlows));
    for (let js of this.exportExcelMydocModel) {
      delete js.id;
      delete js.created_dt;
      delete js.created_by;
      delete js.update_dt;
      delete js.updated_by;
      delete js.effective_date;
      delete js.cdt;
      delete js.udt;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelMydocModel.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'Workflow List',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  public customSort = (event) => {
    console.log(event);
  }

  saveFlow(flowFrom: NgForm) {
    this.workflowsObj.active_flag = "Y";
    this.workflowsObj.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workflowsObj.created_dt = new Date();
    console.log(this.workflowsObj);
    this.approvalFlowService.addFlow(this.workflowsObj).subscribe
      (response => {
        response = response as ErrorResponseMessage;
        this.notificationService.notify(NotificationType.SUCCESS, `Flow Added successfully`);
        this.loadWorkflowNames();
        document.getElementById('new-flow-close').click()
        this.showLoading = false;
        this.isSaveFlow = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }
  saveCriteria(crieriaFrom: NgForm) {
    console.log(this.workflowDefination);
    this.workflowCriteria.created_dt = new Date();
    this.workflowCriteria.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workflowCriteria.flow_id = this.workflowDefination.flowId;
    if (this.workflowCriteria.criteria_type === 'Level Criteria') {
      if (this.workflowDefination.level != null) {
        this.workflowCriteria.level = this.workflowDefination.level;
        this.workflowCriteria.stage = null;
        this.addCriteria(crieriaFrom)
      }
      else {
        this.notificationService.notify(NotificationType.ERROR, `Please enter the level`);
      }
    }
    else if (this.workflowCriteria.criteria_type === 'Stage Criteria') {
      if (this.workflowDefination.level != null && this.workflowDefination.stage != null) {
        this.workflowCriteria.level = this.workflowDefination.level;
        this.workflowCriteria.stage = this.workflowDefination.stage;
        this.addCriteria(crieriaFrom)
      }
      else {
        this.notificationService.notify(NotificationType.ERROR, `Please enter the level and stage`);
      }
    }
  }

  addCriteria(crieriaFrom: NgForm) {

    console.log(this.workflowCriteria);
    this.approvalFlowService.addCriteriaToWorkflow(this.workflowCriteria).subscribe
      (response => {
        response = response as ErrorResponseMessage;

        this.notificationService.notify(NotificationType.SUCCESS, `Criteria Added successfully`);
        //this.clickButton('new-critForm-close');
        document.getElementById('new-critForm-close').click()
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  submitWorkflow(workFlowForm: NgForm) {
    console.log(this.workflowDefination);
    this.workflowDefination.created_dt = new Date();
    this.workflowDefination.created_by =localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.approvalFlowService.createWorkFlowDef(this.workflowDefination).subscribe
      (response => {
        response = response as ErrorResponseMessage;

        this.notificationService.notify(NotificationType.SUCCESS, `Added successfully`);
        workFlowForm.reset();
        this.clickButton('new-workflow-close');
        this.showLoading = false;
        this.isSaveCrit = false;
      }, (errorResponse: HttpErrorResponse) => {
        this.showLoading = false;
        this.isSaveCrit = true;
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

  }

  close(Form: NgForm) {
    Form.reset();
    this.hideApprovalVal = false;
    //this.isSaveCrit = true;
  }

  updateWorkflow(workFlowForm: NgForm) {
    console.log(this.updateWorkflowDetails);

    this.approvalFlowService.updateWorkFlowDef(this.updateWorkflowDetails).subscribe
      (response => {
        response = response as ErrorResponseMessage;

        this.notificationService.notify(NotificationType.SUCCESS, `Updated successfully`);
        workFlowForm.reset();
        this.clickButton('new-updateworkflow-close');
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        this.showLoading = false;
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
    window.location.reload();
  }

  public openCriteriaPopUp(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public runSql() {
    console.log(this.workflowCriteria.criteria_sql);
    this.approvalFlowService.runSql(this.workflowCriteria.criteria_sql)
      .subscribe((data: any) => {
        console.log(data.message);
        if (data.message === 'sucessTrue' || data.message === 'sucessFalse') {
          this.isSaveCrit = false;
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Query compiled Sucess...! Save the query")
        }
        else {
          this.isSaveCrit = true;
          this.notificationService.sendNotification(NotificationType.ERROR, data.message);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  findFlowId(event: any) {
    console.log(event);
    this.workFlows.forEach((workflow: WorkflowNames, index: any) => {
      if (workflow.workflow_name === event.target.value) {
        this.workflowDefination.flowId = workflow.id;
        this.findWorkflowDefById(workflow.id);
      }
    })

  }

  getAllUserData() {
    this.manageUserService.getPendingUsers()
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        console.log(this.userData);
        for (let user of this.userData) {
          this.suppervisorSet.add(user.supervisor_name);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  findCriteriaCode(event: any) {
    if (event.target.value === 'SQL')
      this.isSql = true
    else
      this.isSql = false;
  }



  findApprovalValue1(event: any) {
    this.approvalValueSet = [];
    if (event.target.value === 'By SalesRep Sup') {
      this.hideApprovalVal = true;
      console.log(this.manageUserService.loginUserData.supervisor_name);
      //this.workflowDefination.approval_value = this.manageUserService.loginUserData.supervisor_name;
    } else if (event.target.value === 'By SalesRep') {
      this.hideApprovalVal = true;
      console.log(this.manageUserService.loginUserData.supervisor_name);
      //this.workflowDefination.approval_value = this.manageUserService.loginUserData.supervisor_name;
    } else if (event.target.value === 'By Cust Group') {
      this.hideApprovalVal = false;
      this.approvalFlowService.getAllApprovalWorkFlows()
        .subscribe((data: WorkflowApproval[]) => {
          this.allWorkflowApprovals = data;
          for (let approval of this.allWorkflowApprovals) {
            const workflowApprovalmodel = new WorkflowApproval();
            let approvalVal = approval.approvalId + '_' + approval.name;
            workflowApprovalmodel.name = approvalVal;
            workflowApprovalmodel.employee_id = approval.approvalId;
            this.approvalValueSet.push(workflowApprovalmodel);
          }
          this.filterApprovalValues();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    } else {
      this.hideApprovalVal = false;

      if (event.target.value === 'By SalesRep') {
        for (let user of this.userData) {
          const workflowApprovalmodel = new WorkflowApproval();
          let approvalVal = user.first_name + ' ' + user.last_name + '_' + user.employeeId
          if (user.user_type)
            approvalVal = approvalVal + '_' + user.user_type
          workflowApprovalmodel.name = approvalVal;
          workflowApprovalmodel.employee_id = user.employeeId;
          this.approvalValueSet.push(workflowApprovalmodel);
        }
      } else if (event.target.value === 'By Role') {
        this.usermanagementService.getRoles().subscribe(
          (response: UserManagementModel[]) => {
            this.roles = response;
            for (let role of this.roles) {
              const workflowApprovalmodel = new WorkflowApproval();
              workflowApprovalmodel.name = role.role_name;
              workflowApprovalmodel.employee_id = role.role_name;
              this.approvalValueSet.push(workflowApprovalmodel);
            }
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      }

      this.filterApprovalValues();
    }
  }
  filterApprovalValues() {
    this.filteredApprovalValues = this.control.valueChanges.pipe(
      startWith(''),
      map(value => value.length >= 3 ? this._filter(value) : [])
    );
    console.log(' filteredApprovalValues', this.filteredApprovalValues)
  }

  private _filter(value: string): WorkflowApproval[] {
    const filterValue = this._normalizeValue(value);
    this.filteredValues = this.approvalValueSet.filter(street => this._normalizeValue(street.name).includes(filterValue));

    return this.approvalValueSet.filter(street => this._normalizeValue(street.name).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    console.log(" action ....", action);
    if (action === "Add Workflow") {
      if (!this.isAccessDisabled)
        document.getElementById(action).click();
    } else if (action === "Custom Group") {
      this.redirect('manage-approval');
    }
  }

  innerRowAction(row: any) {
    if (row.value === 'View')
      this.loadStages(row.row.flowId, row.row.level);
    else if (row.value === 'Delete' && !this.isAccessDisabled)
      this.deleteWorkflowLevel(row.row.flowId, row.row.level);
  }

  innerRowAction3(row: any) {
    if (row.value === 'Update' && !this.isAccessDisabled) {
      this.updateWorkflowDetails = row.row;
      console.log(this.updateWorkflowDetails);

      if (row.row.approval_type === 'By User') {
        this.hideApprovalValByUserEdit = false;
        this.hideApprovalValByRoleEdit = true;
        this.hideApprovalValByCustGroupEdit = true;
      } else if (row.row.approval_type === 'By Role') {
        this.hideApprovalValByUserEdit = true;
        this.hideApprovalValByRoleEdit = false;
        this.hideApprovalValByCustGroupEdit = true;
      } else if (row.row.approval_type === 'By Cust Group') {
        this.hideApprovalValByUserEdit = true;
        this.hideApprovalValByRoleEdit = true;
        this.hideApprovalValByCustGroupEdit = false;
      } else {
        this.hideApprovalValByUserEdit = true;
        this.hideApprovalValByRoleEdit = true;
        this.hideApprovalValByCustGroupEdit = true;
      }
      document.getElementById('Update Workflow').click();
    }
    else if (row.value === 'Delete' && !this.isAccessDisabled) {
      this.deleteWorkflowByStage(row.row.id);
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns2 = this.columnsData.Levels;
        this.ordersTableColumns3 = this.columnsData.Stages;
        this.ordersTableColumns = this.columnsData.WorkFlow;
        this.ordersTableColumns4 = this.columnsData.WorkFlowDefinitons;

        console.log(this.ordersTableColumns3);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    // this.buttons = [
    //   {
    //     name: 'Manage Custom Group List',
    //     pagenavigation: 'manage-approval'
    //   }
    // ],
    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }

    ],
      this.actionButtons = [
        {
          name: 'Custom Group',
          pagenavigation: 'manage-approval',
          class: 'btn btn-primary btn-xs'
        },
        {
          name: 'Add Workflow',
          class: 'btn btn-success btn-xs'
        }
      ]
  }
}
